import type { MappingAction, MappingProposal } from './types';

/** `actionByKey` / `onActionChange` key for one proposal row. */
export function reviewRowKey(entityType: string, rawKey: string): string {
  return `${entityType}::${rawKey}`;
}

/** The action a row is currently showing: the override if set, else the proposed action. */
export function effectiveAction(
  entityType: string,
  proposal: MappingProposal,
  actionByKey: Record<string, MappingAction>
): MappingAction {
  return (
    actionByKey[reviewRowKey(entityType, proposal.raw_key)] ??
    proposal.proposed_action
  );
}

export interface PartitionedProposals {
  mapExisting: MappingProposal[];
  createNew: MappingProposal[];
  skip: MappingProposal[];
}

/** Partitions an entity type's proposals into the three review groups by effective action. */
export function partitionProposalsByAction(
  entityType: string,
  proposals: MappingProposal[],
  actionByKey: Record<string, MappingAction>
): PartitionedProposals {
  const result: PartitionedProposals = {
    mapExisting: [],
    createNew: [],
    skip: [],
  };
  for (const proposal of proposals) {
    const action = effectiveAction(entityType, proposal, actionByKey);
    if (action === 'map_existing') {
      result.mapExisting.push(proposal);
    } else if (action === 'create_new') {
      result.createNew.push(proposal);
    } else {
      result.skip.push(proposal);
    }
  }
  return result;
}
